var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dollar-input"},[_c('label',[_vm._v("$")]),_vm._v(" "),_c('div',{staticClass:"dollar-input-padding"},[_c('input',{ref:"input",attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)},"focus":_vm.selectAll,"blur":_vm.formatValue}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }